import { render, staticRenderFns } from "./RouteItemStopsPlanned.vue?vue&type=template&id=3647d47f&scoped=true"
import script from "./RouteItemStopsPlanned.vue?vue&type=script&lang=js"
export * from "./RouteItemStopsPlanned.vue?vue&type=script&lang=js"
import style0 from "./RouteItemStopsPlanned.vue?vue&type=style&index=0&id=3647d47f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3647d47f",
  null
  
)

export default component.exports